import { render, staticRenderFns } from "./vendors-disabled.vue?vue&type=template&id=745422f8&scoped=true"
import script from "./vendors-disabled.vue?vue&type=script&lang=js"
export * from "./vendors-disabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745422f8",
  null
  
)

export default component.exports